module.exports = __webpack_public_path__ + "static/media/layer7.2914c495.png";